import Alert from '@mui/material/Alert';
import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { useTranslation } from 'react-i18next';
import type { PartnerNames } from '../../../utils/mapDataPartnerNames';
import type { AudiencePricingResult } from '../../sections/MultiPartnerPricing';
import { PartnerPricingAlert } from './PartnerPricingAlert';

type PartnerPricingProps = {
  prices: AudiencePricingResult['computePricing']['pricing_by_org'];
  partnerNames: PartnerNames;
  loading: boolean;
  error: Error | null;
};

export const PartnerPricing = ({ prices, partnerNames, loading, error }: PartnerPricingProps) => {
  const { t } = useTranslation();

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <Alert severity="error">{t('Could not get organizations data from the server')}</Alert>;
  }

  return <PartnerPricingAlert prices={prices} partnerNames={partnerNames} />;
};
